import { ModelInfo } from '../model-info'
import { toLocaleDateStringWithFormat } from '@/user/helpers/i18n.helper.js'
import { APPLY_STATE } from './exam-state-enum'
import _ from 'lodash'
import moment from 'moment'

/**
 * @class UserCertificationApplied
 * @classdesc 사용자 접수한 시험 목록 뷰
 */
class AppliedExamContent {
  /**
   * @constructor
   * @param {number} data.id - 시험 아이디
   * @param {string} data.applicantId - 사용자 아이디
   * @param {string} data.examName - 시험 이름
   * @param {string} data.examCode - 자격 시험 코드
   * @param {string} data.examNumber - 수험번호
   * @param {Date} data.startAt - 시작 일시
   * @param {Date} data.appliedAt - 접수 / 결제일시
   * @param {Date} data.canceledAt - 취소 일시
   * @param {string} data.applyState - 접수 상태 (DRAFT, APPLIED, CANCELED)
   * @param {string} data.testLink - 시험 링크
   * @param {number} data.amount - 결제 금액
   */
  constructor(data) {
    this.id = data.examId
    this.applicantId = data.applicantId
    this.examName = data.examName
    this.examCode = data.examCode
    this.examNumber = data.examNumber
    this.startAt = data.startAt
    this.appliedAt = data.appliedAt
    this.canceledAt = data.canceledAt
    this.applyState = APPLY_STATE[data.applyState]
    this.originApplyState = data.applyState
    this.testLink = data.testLink
    this.amount = data.amount
    this.level = data.level
  }

  getStartAtDate() {
    if (this.startAt) {
      return _.curry(toLocaleDateStringWithFormat)(this.startAt)('YYYY-MM-DD HH:mm')
    } else {
      return '-'
    }
  }
  getAppliedAt() {
    if (this.appliedAt) {
      return _.curry(toLocaleDateStringWithFormat)(this.appliedAt)('YYYY-MM-DD HH:mm')
    } else {
      return '-'
    }
  }

  getCanceledAt() {
    if (this.canceledAt) {
      return _.curry(toLocaleDateStringWithFormat)(this.canceledAt)('YYYY-MM-DD HH:mm')
    } else {
      return '-'
    }
  }

  isNotCanceled() {
    return this.originApplyState !== 'CANCELED'
  }

  getExamChangeable() {
    const daysUntilExamStart = moment(moment(this.startAt).format('YYYY-MM-DD')).diff(
      moment().format('YYYY-MM-DD'),
      'days'
    )

    return (
      this.getAppliedAt() !== '-' && // 지원한 시간이있야함
      this.getCanceledAt() === '-' &&
      daysUntilExamStart >= 2
    ) // 취소한 시간이 없어야함
  }

  getExamCancelable() {
    return this.getExamChangeable()
  }
}

export class AppliedExamInfo extends ModelInfo {
  constructor(data) {
    super(data)
    this.content = data.content.map((obj) => new AppliedExamContent(obj))
  }
}
